import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowTriangleLeft: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconArrowTriangleLeft"><Path d="M16.3874 4.26664C18.0469 3.43716 20 4.64337 20 6.49881V17.5024C20 19.3579 18.0469 20.5641 16.3874 19.7346L5.37998 14.2328C3.54001 13.3131 3.54001 10.6881 5.37998 9.76846L16.3874 4.26664Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowTriangleLeft;
